/**
 * Die Anwendungsversion — an genau einer Stelle.
 *
 * Sie stand in `App.tsx`. Das war unproblematisch, solange nur die Verwaltungs-App sie
 * brauchte. Das Helfer-Portal ist aber ein **eigener Webpack-Chunk** (`HelferApp`, siehe
 * `index.tsx`): Ein Import aus `App.tsx` haette dort die komplette Verwaltungs-App
 * mitgezogen — fuer eine Zeichenkette.
 *
 * Deshalb ein eigenes Modul ohne weitere Abhaengigkeiten. `App.tsx` reicht sie weiter, damit
 * bestehende Importe unveraendert funktionieren.
 *
 * **Beim Anheben einer Version wird DIESE Datei geaendert**, nicht mehr `App.tsx`.
 */
export const APP_VERSION = 'V6.135.0';
